module.exports = __webpack_public_path__ + "media/images/flags/32/Grenada-d03054f46835d597eb3a36f7b89e6175.png";